import { useForm } from 'react-hook-form';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslation } from 'next-i18next';
import { useDialog } from '@zep/dialog';
import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, DialogOverlay, DialogPanel, DialogTitle, Input, TextField } from '@zep/ui';
import { useSetPaymentCardName } from '../../../../../services';
import { InputCardNameSchema, InputCardNameSchemaType, RegisterPaymentSchemaSpec, SubscriptionTKey } from '../schema/PaymentCardSchema';
import S from './InputCardNameModal.module.scss';
const InputCardNameModalInner = ({
  spaceHashId,
  onSuccess
}: {
  spaceHashId: string;
  onSuccess: (cardName: string) => void;
}) => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    visible,
    remove
  } = useModal();
  const {
    getValues,
    handleSubmit,
    register,
    formState: {
      isDirty,
      errors
    }
  } = useForm<InputCardNameSchemaType>({
    resolver: zodResolver(InputCardNameSchema),
    mode: 'onBlur',
    defaultValues: {
      name: ''
    }
  });
  const dialog = useDialog();
  const {
    mutateAsync
  } = useSetPaymentCardName();
  const isLoading = false;
  const enabled = !(!isDirty || isLoading);
  const saveCardName = async () => {
    const {
      name: cardName
    } = getValues();
    try {
      await mutateAsync({
        spaceHashId,
        cardName
      });
      onSuccess(cardName);
    } catch (e) {
      // TODO: 언노운에러 로컬라이징
      dialog.alert({
        // @ts-ignore
        title: e.message ?? 'error'
      });
      console.error(e);
    }
  };
  return <Dialog maxWidth={'320px'} open={visible} onClose={() => null} afterClose={remove} drawer data-sentry-element="Dialog" data-sentry-component="InputCardNameModalInner" data-sentry-source-file="InputCardNameModal.tsx">
      <DialogOverlay data-sentry-element="DialogOverlay" data-sentry-source-file="InputCardNameModal.tsx" />
      <DialogPanel data-sentry-element="DialogPanel" data-sentry-source-file="InputCardNameModal.tsx">
        <DialogHeader topSlot={'💳'} data-sentry-element="DialogHeader" data-sentry-source-file="InputCardNameModal.tsx">
          <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="InputCardNameModal.tsx">
            {t('subscription:paymentPayple.modalCardRegister.title')}
          </DialogTitle>
        </DialogHeader>
        <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="InputCardNameModal.tsx">
          <TextField error={Boolean(errors.name)} helperText={t(errors.name?.message as SubscriptionTKey)} label={<span className={S.label}>
                {t('subscription:paymentPayple.modalCardRegister.description')}
              </span>} data-sentry-element="TextField" data-sentry-source-file="InputCardNameModal.tsx">
            <Input isFullWidth {...register('name')} placeholder={t('subscription:paymentPayple.modalCardRegister.placeholder')} error={Boolean(errors.name)} maxLength={RegisterPaymentSchemaSpec.name.maxLength} data-sentry-element="Input" data-sentry-source-file="InputCardNameModal.tsx" />
          </TextField>
        </DialogContent>
        <DialogFooter data-sentry-element="DialogFooter" data-sentry-source-file="InputCardNameModal.tsx">
          <Button disabled={!enabled} onClick={handleSubmit(saveCardName)} data-sentry-element="Button" data-sentry-source-file="InputCardNameModal.tsx">
            {t('subscription:paymentPayple.modalCardRegister.buttonConfirm')}
          </Button>
        </DialogFooter>
      </DialogPanel>
    </Dialog>;
};
export const InputCardNameModal = NiceModal.create(InputCardNameModalInner);